import React, {useEffect, useRef} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import NotificationSystem from 'react-notification-system';
import locales from '../../../locales';
import config from '../../../config';
import InfoIcon from '../../../assets/icons/InfoIcon';
import XIcon from '../../../assets/icons/XIcon';
import './styles.css';
import SilverButton from "../../buttons/SilverButton";
import CircleAlertIcon from "../../../assets/icons/CircleAlertIcon";
import CheckCircleIcon from "../../../assets/icons/CheckCircleIcon";

const icons = {
    info: <InfoIcon width={20} height={20}/>,
    warning: <CircleAlertIcon size={20} stroke="currentColor"/>,
    error: <CircleAlertIcon size={20} stroke="currentColor"/>,
    success: <CheckCircleIcon width={20} height={20}/>,
};

const ToastContent = ({level, title, description, onClose}) => (
    <div className="app-toast">
        <span className={`app-toast__icon app-toast__icon--${level}`} aria-hidden="true">{icons[level]}</span>

        <div className="app-toast__body">
            {title && <div className="app-toast__title">{title}</div>}
            {description && <div className="app-toast__description">{description}</div>}
        </div>

        <SilverButton
            type="button"
            variant="ghost"
            className="app-toast__close"
            width="20px"
            height="20px"
            iconOnly
            expandedHover
            styles={{padding: 0, flexShrink: 0, border: 0}}
            onClick={onClose}
        >
            <XIcon width={20} height={20} stroke="var(--ds-fg-quaternary-400)"/>
        </SilverButton>

    </div>
);

ToastContent.propTypes = {
    level: PropTypes.oneOf(['info', 'warning', 'error', 'success']).isRequired,
    title: PropTypes.node,
    description: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const notificationItemStyle = {
    backgroundColor: '#fff',
    border: '1px solid var(--ds-border-primary)',
    borderTop: '1px solid var(--ds-border-primary)',
    boxShadow: 'none',
    color: 'var(--ds-text-secondary)',
};

const Notification = ({notification, user}) => {
    const notificationSystem = useRef(null);
    const lastNotification = useRef(null);

    useEffect(() => {
        if (!notification || (!notification.message && !notification.title && !notification.description)) return;
        if (notification === lastNotification.current || !notificationSystem.current) return;
        lastNotification.current = notification;

        const language = user.language;
        const translate = value => typeof value === 'string'
            ? ((locales[language] && locales[language][value]) || value)
            : value;
        const level = icons[notification.level] ? notification.level : config.notificationLevels.info;
        const title = translate(notification.title || notification.message);
        const description = translate(notification.description || (notification.title && notification.message));
        let addedNotification;

        addedNotification = notificationSystem.current.addNotification({
            position: 'br',
            autoDismiss: 3,
            ...notification,
            level,
            title: null,
            message: null,
            action: null,
            dismissible: 'none',
            children: (
                <ToastContent level={level} title={title} description={description} onClose={() => {
                    if (notificationSystem.current && addedNotification) {
                        notificationSystem.current.removeNotification(addedNotification);
                    }
                }}/>
            ),
        });
    }, [notification, user.language]);

    return (
        <NotificationSystem
            ref={notificationSystem}
            style={{
                Containers: {
                    br: {
                        top: 'auto',
                        bottom: '0px',
                        paddingBottom: '0px',
                        right: '0px',
                        left: 'auto',
                        width: 'min(360px, calc(100vw - 16px))',
                        zIndex: 999999,
                    },
                },
                NotificationItem: {
                    DefaultStyle: {
                        ...notificationItemStyle,
                        borderRadius: '12px',
                        padding: '16px',
                        marginBottom: '12px',
                        opacity: 0,
                        overflow: 'hidden',
                    },
                    success: notificationItemStyle,
                    error: notificationItemStyle,
                    info: notificationItemStyle,
                    warning: notificationItemStyle,
                },
            }}
        />
    );
};

Notification.propTypes = {
    notification: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({notification: state.notification, user: state.user});

export default connect(mapStateToProps)(Notification);



// WEBPACK FOOTER //
// ./src/components-new/general/Notifications/index.jsx